import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { ConfiguredCarStaticCatalogDocument, ModelCatalogInput } from '~/graphql/__generated__/graphql';
import { imageSetFilterStatic } from '~/graphql/hooks/use-configured-car-queries';

export function useConfiguredCarStaticCatalog() {
	const [fetchStandardEquipmentData, { data, previousData, loading }] = useLazyQuery(
		ConfiguredCarStaticCatalogDocument,
		{
			returnPartialData: true,
			fetchPolicy: 'no-cache',
		},
	);

	const fetchStandardEquipment = useCallback(
		(input: ModelCatalogInput) => {
			return fetchStandardEquipmentData({
				variables: {
					input,
					imageTypeFilterInput: imageSetFilterStatic,
				},
			});
		},
		[fetchStandardEquipmentData],
	);

	return {
		fetchStandardEquipment,
		selectedStandardEquipment: data ?? previousData,
		isLoading: loading,
	};
}
